
import { defineComponent, PropType } from 'vue'
import VoteButton from './VoteButton.vue'
import Bar from './Bar.vue'
import DappInfo from './DappInfo.vue'
import { Dapp, DappLocalState } from '@/types'
import LocalStateInfo from './LocalStateInfo.vue'
import ClaimButton from './ClaimButton.vue'
import ReclaimButton from './ReclaimButton.vue'

export default defineComponent({
    name: 'DappBlock',
    props: {
        dapp: {
            type: Object as PropType<Dapp>,
            required: true
        },
        localState: {
            type: Object as PropType<DappLocalState>,
            required: false
        },
        team1Color: {
            type: String,
            default: "#72C076" 
        },
        team2Color: {
            type: String,
            default: "#73CDD3"
        },
    },
    components: {
        VoteButton,
        Bar,
        DappInfo,
        LocalStateInfo,
        ClaimButton,
        ReclaimButton
    },
    computed: {
        myTeamColor(): string {
            if ((this.localState as DappLocalState).Team === this.dapp.Team1.Name) {
                return this.team1Color;
            } else {
                return this.team2Color;
            }
        },
        winningTeamColor(): string {
            if (this.dapp.Winner === this.dapp.Team1.Name) {
                return this.team1Color;
            } else {
                return this.team2Color;
            }
        },
        isVoteable(): boolean {
            return this.dapp.LimitDate * 1000 > Date.now();
        },
        isExpired(): boolean {
            return this.dapp.EndDate * 1000 < Date.now();
        },
        isWinner(): boolean {
            return ((this.localState as DappLocalState).Team === this.dapp.Winner)
        },
        hasClaimed(): boolean {
            return ((this.localState as DappLocalState).Bet === 0)
        }
    }
})
